import React, { useState } from 'react';
import UserProfileToggle from '../user_profile_toggle';
import PropTypes from 'prop-types';

export default function SharedSpecialtyLogic({
  getPropertyType,
  pcUser = false,
  selectedOptionsById,
  showSpecialtiesOnBrokerPlugin,
  userSpecialties
}) {
  const [specialtiesOnBrokerPlugin, setSpecialtiesOnBrokerPlugin] = useState(showSpecialtiesOnBrokerPlugin);

  const pcUserPrefix = pcUser ? 'parent_company_' : '';
  const specialtyBaseName = `${pcUserPrefix}user[${pcUserPrefix}user_broker_specialties_attributes]`;

  const persistedBrokerSpecialties = userSpecialties.map(s => s.brokerSpecialtyId);
  const newSpecialtyIds = Object.keys(selectedOptionsById).filter(s => (
    !persistedBrokerSpecialties.includes(Number(s))
  ));

  return (
    <React.Fragment>
      {userSpecialties.map((userSpecialty, index) => {
        const specialtyObject = selectedOptionsById[userSpecialty.brokerSpecialtyId];

        return (
          <React.Fragment key={userSpecialty.id}>
            <input name={`${specialtyBaseName}[${index}][id]`} type="hidden" value={userSpecialty.id}/>
            <input
              name={`${specialtyBaseName}[${index}][broker_specialty_id]`}
              type="hidden"
              value={userSpecialty.brokerSpecialtyId}
            />
            <input
              name={`${specialtyBaseName}[${index}][property_type]`}
              type="hidden"
              value={specialtyObject?.values ? getPropertyType(specialtyObject.values) : ''}
            />
            <input
              name={`${specialtyBaseName}[${index}][_destroy]`}
              type="hidden"
              value={!specialtyObject}
            />
          </React.Fragment>
        );
      })}

      {newSpecialtyIds.map((specialtyId, i) => {
        const index = i + userSpecialties.length;
        const specialtyObject = selectedOptionsById[specialtyId];

        return (
          <React.Fragment key={specialtyId}>
            <input
              name={`${specialtyBaseName}[${index}][broker_specialty_id]`}
              type="hidden"
              value={specialtyId}
            />
            <input
              name={`${specialtyBaseName}[${index}][property_type]`}
              type="hidden"
              value={getPropertyType(specialtyObject.values)}
            />
          </React.Fragment>
        );
      })}

      {!pcUser &&
        <UserProfileToggle
          checked={specialtiesOnBrokerPlugin}
          label="Show on Broker Plugin"
          name="user[show_specialties_on_broker_plugin]"
          onChange={() => setSpecialtiesOnBrokerPlugin(!specialtiesOnBrokerPlugin)}
        />
      }
    </React.Fragment>
  );
}

export const userSpecialties = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  brokerSpecialtyId: PropTypes.number,
  propertyType: PropTypes.string
})).isRequired;

export const specialtiesPropTypes = {
  allBrokerSpecialties: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    propertyType: PropTypes.string
  })).isRequired,
  showSpecialtiesOnBrokerPlugin: PropTypes.bool.isRequired,
  userSpecialties: userSpecialties
};

SharedSpecialtyLogic.propTypes = {
  ...userSpecialties,
  getPropertyType: PropTypes.func.isRequired,
  pcUser: PropTypes.bool,
  selectedOptionsById: PropTypes.object,
  showSpecialtiesOnBrokerPlugin: PropTypes.bool
};
